export function withSortableColumnFlag(columns, sortableFields) {
    const sortableColumnKeys = Object.values(sortableFields);
    return columns.map(column => ({
        ...column,
        sortable: sortableColumnKeys.includes(column.id)
    }));
}
